import { forwardRef, useContext } from 'react';
import styles from '../Input.module.css';
import { InputContext } from '../Input';
import { altoConsole } from '../../../../utils/console/console';

interface SuffixProps {
  children: string;
  visuallyHiddenLabel?: string;
}

const InputSuffix = forwardRef<HTMLDivElement, SuffixProps>(
  ({ children, visuallyHiddenLabel }, ref) => {
    const state = useContext(InputContext);

    if (typeof children !== 'string') {
      altoConsole.error(
        'Input.Suffix only accepts a single string as a child',
        { scope: 'Input' },
      );
    }

    return (
      <div
        ref={ref}
        className={styles['input-field__suffix']}
        {...(state.isDisabled ? { 'data-disabled': true } : {})}
        {...(state.isInvalid ? { 'data-invalid': true } : {})}
        data-suffix-type="text"
        aria-hidden={visuallyHiddenLabel ? 'true' : undefined}
      >
        {children}
      </div>
    );
  },
);
InputSuffix.displayName = 'Input.Suffix';

export default InputSuffix;
